import { LogLevel } from '@azure/msal-browser'

const clientId = import.meta.env.VITE_APPLICATION_ID
const authority = `https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID}`
const redirectUri = window.location.origin + '/src/taskpane/taskpane.html'

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage', // Required for NAA to work properly and enable SSO
    storeAuthStateInCookie: true, // Important for NAA to work with redirect flow
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL Error]', message)
            return
          case LogLevel.Warning:
            console.warn('[MSAL Warning]', message)
            return
          default:
            // Suppress Info and Verbose logs to reduce noise
            return
        }
      },
    },
  },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [`${import.meta.env.VITE_API_URL}/user_impersonation`],
}
